import Vuex from 'vuex'

import config from "@/config.js"

import {cityModule} from "@/store/modules/city.js";
import {authModule} from "@/store/modules/auth.js";
import {userModule} from "@/store/modules/user.js";
import {catalogModule} from "@/store/modules/catalogModule.js";
import {mainBanner} from "@/store/modules/mainBanner.js";
import {cartModule} from "@/store/modules/cart.js";
import {productModal} from "@/store/modules/productModal.js";
import SettingSource from "@/api/SettingSource.js";
import {shippingModule} from "@/store/modules/shipping.js";
import {orderModule} from "@/store/modules/order.js";
import {paymentModule} from "@/store/modules/payment.js";
import {couponModule} from "@/store/modules/coupon.js";
import {rewardModule} from "@/store/modules/reward.js";
import {productDetailModule} from "@/store/modules/productDetail.js";
import {newsModule} from "@/store/modules/news.js";
import {articleModule} from "@/store/modules/article.js";
import profileModal from "@/store/modules/profileModal.js";

const plugins = [];

if (typeof import.meta.env !== 'undefined' && !import.meta.env.SSR) {
    plugins.push(
        (store) => {
            return new Promise(async (resolve) => {
                try {
                    const createPersistedState = (await import('vuex-persistedstate')).default;
                    createPersistedState({
                        key: 'krd-store',
                        paths: ['shipping.pickupData']
                    })(store)
                } catch {
                    // чанк не загрузился — сохранённый shipping.pickupData просто не восстановится
                }

                resolve()
            })
        }
    )
}

export function createStore() {
    return new Vuex.Store(
        {
            state() {
                return   {
                    settings: {},
                    canonical: null,
                    lastModified: null,
                    message403: null,
                    mainLoader: false,
                    stopListModal: false,
                    isMobile: false,
                    showLoginModal: false,
                    meta: {
                        title: null,
                        description: null,
                        robots: null,
                        ogImage: null,
                        canonical: null,
                        keywords: null,
                        ogImageDefault: '/assets/ogimage.webp?v=2',
                        defaultTitle: 'Краснодарский парень',
                        defaultDescription: `Краснодарский парень`,
                        defaultKeywords: 'Краснодарский парень',
                    }
                }
            },
            getters: {
                getMetaInfo: (state) => {
                    let url = String(state?.city?.currentCity?.url ?? config.hostname ?? '');
                    url = url.replace('.ru/', '.ru')
                    let canonical = url + (state?.canonical ?? '/');

                    if (typeof url !== 'string') {
                        url = '';
                    }

                    canonical = String(canonical)
                        .replace(/\/\//g, '/')
                        .replace(/https:\//g, 'https://');

                    const meta =  [
                        `<title meta-info>${state.meta.title ?? state.meta.defaultTitle}</title>`,
                        `<link meta-info rel="canonical" href="${canonical}" />`,
                        `<meta meta-info name="description" content="${state.meta.description ?? state.meta.defaultDescription}">`,
                        `<meta meta-info name="keywords" content="${state.meta.keywords ?? state.meta.defaultKeywords}">`,
                        `<meta meta-info property="robots" content="${state.meta.robots ?? 'index'}">`,
                        `<meta meta-info property="og:url" content="${url}">`,
                        `<meta meta-info property="og:type" content="website">`,
                        `<meta meta-info property="og:title" content="${ state.meta.title ?? state.meta.defaultTitle }">`,
                        `<meta meta-info property="og:description" content="${state.meta.description ?? state.meta.defaultDescription}">`,
                        `<meta meta-info property="og:image" content="${url}${state.meta.ogImage ?? state.meta.ogImageDefault}">`,
                        `<meta meta-info property="og:image:width" content="600">`,
                        `<meta meta-info property="og:image:height" content="315">`,
                        `<meta meta-info name="twitter:card" content="summary_large_image">`,
                        `<meta meta-info property="twitter:domain" content="${url.replace('https://', '')}">`,
                        `<meta meta-info property="twitter:url" content="${url}">`,
                        `<meta meta-info name="twitter:title" content="${ state.meta.title ?? state.meta.defaultTitle }">`,
                        `<meta meta-info name="twitter:description" content="${state.meta.description ?? state.meta.defaultDescription}">`,
                        `<meta meta-info name="twitter:image" content="${state.meta.ogImage ?? state.meta.ogImageDefault}">`,
                        `<link meta-info rel="image_src" href="${url}${state.meta.ogImage ?? state.meta.ogImageDefault}">`,

                        `<meta property="og:type" content="restaurant">`,
                        `<meta property="og:title" content="Краснодарский парень">`,
                        `<meta property="og:image" content="http://krasnodar.krd-paren.ru/assets/img/logo_new.svg">`,
                        `<meta property="og:priceRange" content="₽">`,
                        `<meta property="og:servesCuisine" content="Fast Food, Burgers, Russian">`,
                        `<meta property="og:telephone" content="${state?.city?.currentCity?.configs?.telephone}">`,
                        `<meta property="og:street-address" content="${state?.city?.currentCity?.configs?.config_address}">`,
                        `<meta property="og:locality" content="${state?.city?.currentCity?.name}">`,
                        `<meta property="og:region" content="RU">`,
                        `<meta property="og:country-name" content="RU">`
                    ]

                    const metrics = state.city?.currentCity?.metrics;

                    if (metrics) {
                        meta.push(metrics);
                    }

                    return meta
                },
            },
            mutations: {
                setMessage403(state, data) {
                    state.message403 = data;
                },
                setStopListModal(state, data) {
                    state.stopListModal = data;
                },
                setMainLoader(state, data) {
                    state.mainLoader = data;
                },
                setShowLoginModal(state, value) {
                    state.showLoginModal = value;
                },
                setMetaTitle(state, text) {
                    if (text === null) {
                        text = state.meta.defaultTitle
                    }
                    state.meta.title = text;
                },
                setMetaTitleWithoutSub(state, text) {
                    if (text === null) {
                        text = state.meta.defaultTitle
                    }
                    state.meta.title = text ;
                },
                setMetaDescription(state, text) {
                    if (text === null) {
                        text = state.meta.defaultDescription
                    }
                    state.meta.description = text;
                },
                setLastModified(state, data) {
                    state.lastModified = data;
                },

                setMetaRobots(state, text) {
                    if (text === null) {
                        text = 'index'
                    }
                    state.meta.robots = text;
                },
                setMetaOgImage(state, src) {
                    if (src === null) {
                        src = state.meta.ogImageDefault
                    }
                    state.meta.ogImage = src;
                },
            },
            actions: {
                async initDeviseType({state}, value) {
                    state.isMobile = value;
                },
                async startUpServer({dispatch}, {cache, dataBridge}) {
                    await Promise.all([
                        await dispatch('loadSettings'),
                        await dispatch('city/list', cache),
                        await dispatch('city/initCityByHost', dataBridge.host),
                        await dispatch('catalog/load')

                    ]);
                },
                async startUpMount({dispatch}) {
                    await Promise.all([
                        await dispatch('shipping/allPolygonsList'),
                        await  dispatch('user/getCurrentUser'),
                        await  dispatch('cart/load').catch(() => {}),
                    ]);
                },
                async loadSettings({state}) {
                    await this.$API.manager.getSource(SettingSource).list().then(async (response) => {
                        state.settings = response;
                    })
                },
                updateMeta({getters}) {
                    if(typeof window !== 'undefined'){
                        document.querySelectorAll('[meta-info]').forEach(function(metaElement) {
                            metaElement.remove();
                        });
                        const fragment = document.createDocumentFragment();
                        getters.getMetaInfo.forEach(function (metaInfo) {
                            const tempDiv = document.createElement('div');
                            tempDiv.innerHTML = metaInfo;
                            const metaElement = tempDiv.firstChild;
                            fragment.appendChild(metaElement);
                        });

                        document.head.appendChild(fragment);
                    }

                }
            },
            modules: {
                city: cityModule,
                auth: authModule,
                user: userModule,
                catalog: catalogModule,
                mainBanner: mainBanner,
                cart: cartModule,
                productModal: productModal,
                profileModal: profileModal,
                shipping: shippingModule,
                order: orderModule,
                payment: paymentModule,
                coupon: couponModule,
                reward: rewardModule,
                productDetail: productDetailModule,
                news: newsModule,
                article: articleModule,
            },

            plugins
        }
    );
}


